import {
  Box,
  Typography,
  Paper,
  Stack,
} from "@mui/material";

export const SEVERITY = {
  high: { color: "#e53e51", label: "High" },
  medium: { color: "#ed6c02", label: "Medium" },
  low: { color: "#2e7d32", label: "Low" },
};

export const sev = (s) => SEVERITY[s] || { color: "#9e9e9e", label: s || "N/A" };

export const confColor = (c) =>
  c === "high" ? "success" : c === "medium" ? "warning" : c === "low" ? "error" : "default";

export const Section = ({ title, icon, gradient, children }) => (
  <Paper
    elevation={0}
    sx={{
      mb: 3,
      borderRadius: 2,
      overflow: "hidden",
      border: "1px solid #eee",
      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    }}
  >
    <Box
      sx={{
        background: gradient,
        color: "#fff",
        py: 1.75,
        px: 2.5,
        display: "flex",
        alignItems: "center",
        gap: 1.25,
      }}
    >
      {icon}
      <Typography sx={{ fontSize: 18, fontWeight: 600 }}>{title}</Typography>
    </Box>
    <Box sx={{ p: 2.5 }}>{children}</Box>
  </Paper>
);

export const Callout = ({ children, bg, border }) => (
  <Box
    sx={{
      bgcolor: bg,
      borderLeft: `4px solid ${border}`,
      borderRadius: 1,
      p: 1.5,
      mb: 2,
    }}
  >
    {children}
  </Box>
);

export const Field = ({ label, value }) => (
  <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
    <Typography sx={{ fontSize: 14, fontWeight: 600, minWidth: 150, color: "#555" }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: 14 }}>{value ?? "N/A"}</Typography>
  </Stack>
);

export const StatCard = ({ label, value, accent, icon }) => (
  <Paper
    elevation={0}
    sx={{
      flex: 1,
      minWidth: 180,
      p: 2,
      borderRadius: 1.5,
      borderLeft: `4px solid ${accent}`,
      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    }}
  >
    <Stack direction="row" alignItems="center" spacing={1}>
      {icon}
      <Typography sx={{ fontSize: 13, color: "#777" }}>{label}</Typography>
    </Stack>
    <Typography sx={{ fontSize: 26, fontWeight: 700, mt: 0.5 }}>{value ?? "N/A"}</Typography>
  </Paper>
);

export const IconList = ({ title, items, icon, color }) => (
  <Box sx={{ mt: 1.5 }}>
    <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 0.75 }}>{title}</Typography>
    <Stack spacing={0.75}>
      {items.map((it, i) => (
        <Stack direction="row" spacing={1} key={i} alignItems="flex-start">
          <Box sx={{ color, mt: "2px", display: "flex" }}>{icon}</Box>
          <Typography sx={{ fontSize: 13, color: "#333" }}>{it}</Typography>
        </Stack>
      ))}
    </Stack>
  </Box>
);

export const Centered = ({ children }) => (
  <Box
    sx={{
      bgcolor: "#f5f5f5",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: 2,
      p: 3,
    }}
  >
    {children}
  </Box>
);